<template>
  <el-tooltip class="item" effect="light" content="Contact Customer Service" placement="top">
    <div class="global-customer-service" @click="jumpToLark">
      <img src="@/assets/images/global-cs-icon.png" alt="customer service" />
    </div>
  </el-tooltip>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  setup() {
    const jumpToLark = () => {
      window.open('https://applink.larksuite.com/TJo3ShU', '_blank')
    }

    return { jumpToLark }
  },
})
</script>

<style lang="stylus" scoped>
.global-customer-service
  position absolute
  bottom 100px
  right 25px
  width 55px
  height 55px
  animation bounce 0.65s
  animation-direction alternate
  animation-timing-function cubic-bezier(0.5, 0.05, 1, 0.5)
  animation-iteration-count infinite
  img
    width 100%
    height auto
.global-customer-service:hover img
  transform scale(1.1)
  transition all 0.25s
@keyframes bounce
  from
    transform translate3d(0, 0, 0)
  to
    transform translate3d(0, 20px, 0)
</style>